﻿interface ConsumoPoint {
  mes: string;
  consumo: number;
}

interface ConsumoChartProps {
  data: ConsumoPoint[];
}

export default function ConsumoChart({ data }: ConsumoChartProps) {
  const maxVal = Math.max(...data.map((d) => d.consumo), 1);

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-semibold text-gray-800">Consumo Mensual</h3>
          <p className="text-xs text-gray-400 mt-0.5">Metros cúbicos totales (m³)</p>
        </div>
        <span className="text-xs border border-gray-200 rounded-lg px-3 py-1.5 text-gray-600">Últimos 12 meses</span>
      </div>

      {data.length === 0 ? (
        <div className="h-40 rounded-lg bg-gray-50 flex items-center justify-center text-sm text-gray-500">
          Sin lecturas para mostrar.
        </div>
      ) : (
        <div className="flex items-end gap-1.5 h-40">
          {data.map((d, index) => {
            const height = (d.consumo / maxVal) * 100;
            const isLast = index === data.length - 1;
            return (
              <div key={`${d.mes}-${index}`} className="flex-1 flex flex-col items-center gap-1 group cursor-pointer">
                <div className="relative w-full flex items-end justify-center" style={{ height: "120px" }}>
                  <div
                    className={`w-full rounded-t-md transition-all duration-300 group-hover:opacity-80 ${isLast ? "bg-blue-600" : "bg-blue-200"}`}
                    style={{ height: `${height}%` }}
                  />
                  <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-1.5 py-0.5 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                    {d.consumo.toLocaleString("es-CL")} m³
                  </div>
                </div>
                <span className="text-xs text-gray-400 whitespace-nowrap">{d.mes}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
